let menuProductsList = null;

export function setMenuProductsList(data) {
	menuProductsList = Object.freeze(data);
}

export function getMenuProductsList() {
	return menuProductsList;
}